 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"icons/icon-account-svg":"icons/icon-account-svg","icons/icon-charges-svg":"icons/icon-charges-svg","icons/icon-check-svg":"icons/icon-check-svg","icons/icon-circle-dot-svg":"icons/icon-circle-dot-svg","icons/icon-circle-svg":"icons/icon-circle-svg","icons/icon-client-svg":"icons/icon-client-svg","icons/icon-close-svg":"icons/icon-close-svg","icons/icon-configuration-svg":"icons/icon-configuration-svg","icons/icon-copy-svg":"icons/icon-copy-svg","icons/icon-cred-card-svg":"icons/icon-cred-card-svg","icons/icon-customers-svg":"icons/icon-customers-svg","icons/icon-dashboard-svg":"icons/icon-dashboard-svg","icons/icon-developer-svg":"icons/icon-developer-svg","icons/icon-direction-svg":"icons/icon-direction-svg","icons/icon-download-svg":"icons/icon-download-svg","icons/icon-edit-svg":"icons/icon-edit-svg","icons/icon-ellipsis-svg":"icons/icon-ellipsis-svg","icons/icon-fees-svg":"icons/icon-fees-svg","icons/icon-freearea-svg":"icons/icon-freearea-svg","icons/icon-hub-svg":"icons/icon-hub-svg","icons/icon-info-svg":"icons/icon-info-svg","icons/icon-invites-svg":"icons/icon-invites-svg","icons/icon-invoices-svg":"icons/icon-invoices-svg","icons/icon-learn-more-svg":"icons/icon-learn-more-svg","icons/icon-logoJPM-svg":"icons/icon-logoJPM-svg","icons/icon-logs-svg":"icons/icon-logs-svg","icons/icon-merchant-svg":"icons/icon-merchant-svg","icons/icon-mundi-svg":"icons/icon-mundi-svg","icons/icon-no-results-svg":"icons/icon-no-results-svg","icons/icon-notification-svg":"icons/icon-notification-svg","icons/icon-orders-svg":"icons/icon-orders-svg","icons/icon-pagarme-svg":"icons/icon-pagarme-svg","icons/icon-payment-links-svg":"icons/icon-payment-links-svg","icons/icon-payments-svg":"icons/icon-payments-svg","icons/icon-permission-svg":"icons/icon-permission-svg","icons/icon-pix-outline-svg":"icons/icon-pix-outline-svg","icons/icon-pix-svg":"icons/icon-pix-svg","icons/icon-plans-svg":"icons/icon-plans-svg","icons/icon-pos-svg":"icons/icon-pos-svg","icons/icon-profile-svg":"icons/icon-profile-svg","icons/icon-recurrence-svg":"icons/icon-recurrence-svg","icons/icon-security-svg":"icons/icon-security-svg","icons/icon-shop-svg":"icons/icon-shop-svg","icons/icon-statistics-svg":"icons/icon-statistics-svg","icons/icon-subscription-svg":"icons/icon-subscription-svg","icons/icon-subscriptions-svg":"icons/icon-subscriptions-svg","icons/icon-test-svg":"icons/icon-test-svg","icons/icon-trf-svg":"icons/icon-trf-svg","icons/icon-users-solid-svg":"icons/icon-users-solid-svg","icons/icon-users-svg":"icons/icon-users-svg","icons/icon-webhooks-config-svg":"icons/icon-webhooks-config-svg","icons/icon-webhooks-skeleton-svg":"icons/icon-webhooks-skeleton-svg","icons/icon-webhooks-svg":"icons/icon-webhooks-svg"}[chunkId]||chunkId) + ".chunk.js?id=" + {"icons/icon-account-svg":"f2369e01a1805361cbbe","icons/icon-charges-svg":"bc90b8806722bbfe01f3","icons/icon-check-svg":"fe6fb8cbd7899cab8002","icons/icon-circle-dot-svg":"ad995fdc35818155a735","icons/icon-circle-svg":"0cf1be668933f6e8f73b","icons/icon-client-svg":"4b7c22bfc6f306fa8c64","icons/icon-close-svg":"aa45c18484c93eee2314","icons/icon-configuration-svg":"0b4524b6fb54e8b0a2c9","icons/icon-copy-svg":"798527e8c7ab5d49e03b","icons/icon-cred-card-svg":"14251be0afa61360e9f0","icons/icon-customers-svg":"7637e0c8f61f0e2795df","icons/icon-dashboard-svg":"d9a3c4f7ce3618d3d144","icons/icon-developer-svg":"bed2d1e4279e891c64da","icons/icon-direction-svg":"264f93f0790e973c66ba","icons/icon-download-svg":"996395fdebe2c15bf295","icons/icon-edit-svg":"bb2090561fb3eb1beaca","icons/icon-ellipsis-svg":"2e1680d155c8b4a8149f","icons/icon-fees-svg":"06b4a3b1a2ee04fe4fbb","icons/icon-freearea-svg":"1f87affea5f240643bb4","icons/icon-hub-svg":"6221bfcc7c945ead56c6","icons/icon-info-svg":"6a297a93d78375e87f98","icons/icon-invites-svg":"20d6fd92751895be1640","icons/icon-invoices-svg":"41361d1ab1a70801a5f3","icons/icon-learn-more-svg":"78ca0e0746bf34c718ff","icons/icon-logoJPM-svg":"d659078cf23005ff3a8d","icons/icon-logs-svg":"e3db5591150b0188ecb2","icons/icon-merchant-svg":"f51234e19f351679eb1c","icons/icon-mundi-svg":"c9cb709105264cba1276","icons/icon-no-results-svg":"c570834dcebc9a632ad4","icons/icon-notification-svg":"5cea5cc129f007c81d0f","icons/icon-orders-svg":"5b5c015eedc78dfe53b9","icons/icon-pagarme-svg":"31f2c642a26b7b80ecc7","icons/icon-payment-links-svg":"61659cc947b3ec69bced","icons/icon-payments-svg":"ca4cbf9c6b798c680fb2","icons/icon-permission-svg":"2b5c6fb25db1c8950587","icons/icon-pix-outline-svg":"3648166bc14708205a38","icons/icon-pix-svg":"ac68eabbd47da3c3c074","icons/icon-plans-svg":"30ff905848be2938089e","icons/icon-pos-svg":"bbc4ffa11067e1a05d37","icons/icon-profile-svg":"3360ca438680d7abe908","icons/icon-recurrence-svg":"3449fba642d46cda03d5","icons/icon-security-svg":"5cbc4678fcd906c29852","icons/icon-shop-svg":"47b26dccf607b447696b","icons/icon-statistics-svg":"5334d5e69c5082c3ddd1","icons/icon-subscription-svg":"cda6c7e7e4718acf8361","icons/icon-subscriptions-svg":"55242eb87f980d5156cb","icons/icon-test-svg":"3b7190419e30ef8f0bf0","icons/icon-trf-svg":"d6b6765b00a02c4ceafd","icons/icon-users-solid-svg":"fe1832a64ae44d82ac80","icons/icon-users-svg":"7ddf4d4f04fcd9b2fee3","icons/icon-webhooks-config-svg":"b8761c8d112c545ef025","icons/icon-webhooks-skeleton-svg":"4ca8018badcf67ec1350","icons/icon-webhooks-svg":"94d103ad66451b2a2456"}[chunkId] + ""
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
